<!--
 * @Description: 订单管理
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 15:06:05
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display:flex">
        <div>
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px;" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px;" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block;margin-bottom: 10px;">
                  <span style="margin-right: 12px;">订单编号</span>
                  <el-input v-model="tableParam.orderNo" style="width: 220px;" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
                <span style="margin-left: 24px;">
                  <span style="margin-right: 12px;">工程名称</span>
                  <el-input v-model="tableParam.engineeringName" style="width: 220px;" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
                <span style="margin-left: 24px;">
                  <span style="margin-right: 12px;">浇筑时间</span>
                  <el-date-picker v-model="tableParam.pouringTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"></el-date-picker>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left:12px;" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card" style="padding-top:10px">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                    <template slot-scope="scope">
                      <span v-if="item.label=='车辆信息'">
                        <span class="table_link" @click="open(scope.row)">添加</span>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" layout="prev, pager, next, jumper" :total="total" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="710px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">添加运输罐车</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="fromDate" label-width="110px">
          <el-form-item>
            <span slot="label">选择罐车</span>
            <el-select v-model="fromDate.arr1" placeholder="请选择" multiple collapse-tags>
              <el-option v-for="(item, index) in arr1" :key="index" :label="item.plateNumber" :value="item.plateNumber"></el-option>
            </el-select>
          </el-form-item>
          <div class="car">
            <div v-for="(item,index) in fromDate.arr1" :key="index">
              <span>{{item}}</span>
              <i class="icon iconfont iconzu2197" @click="del(index)"></i>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px;" @click="submit1()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  queryPage,
  // batchUpdateOrDelete,
  // updateSortNum,
  saveOrupdate,
  // Download,
  cat_list,
  plan_car,
} from "@/api/smart/out/b.js";
export default {
  mixins: [mixin],
  data() {
    return {
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      // batchUpdateOrDelete: batchUpdateOrDelete,
      // updateSortNum: updateSortNum,
      // saveOrUpdate: saveOrUpdate,
      // DownloadURL: Download,
      /*表格数据*/
      table: [
        { label: "订单编号", width: "auto", prop: "orderNo", status: true },
        { label: "产品名称", width: "120", prop: "productName", status: true },
        {
          label: "生产量(方)",
          width: "auto",
          prop: "pouringNum",
          status: true,
        },
        { label: "浇筑时间", width: "120", prop: "pouringTime", status: true },
        {
          label: "浇筑方式",
          width: "auto",
          prop: "pouringMethod",
          status: true,
        },
        {
          label: "工程名称",
          width: "120",
          prop: "engineeringName",
          status: true,
        },
        { label: "施工单位", width: "auto", prop: "roadwork", status: true },
        { label: "工程地址", width: "120", prop: "place", status: true },
        { label: "联系人", width: "auto", prop: "person", status: true },
        { label: "联系电话", width: "120", prop: "phoneNum", status: true },
        { label: "车辆信息", width: "120", prop: "", status: true },
      ],
      pagesType: 0,
      /*添加表单数据*/
      rules: {
        code: [{ required: true, message: "请输入站点编码", trigger: "blur" }],
      },
      fromDate: {
        arr1: "",
      },
      arr1: [],
      oldarr1: [],
      low: {},
    };
  },
  created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = {
      ...this.tableParam,
      orderNo: "",
      engineeringName: "",
      pouringTime: "",
      foreignType: "type_unit",
    };
    this.tableData = [{}];
    // this.addDialog = true;
    // this.arr1 = [
    //   { plateNumber: "川A00001" },
    //   { plateNumber: "川A00002" },
    //   { plateNumber: "川A00003" },
    //   { plateNumber: "川A00004" },
    //   { plateNumber: "川A00005" },
    //   { plateNumber: "川A00006" },
    //   { plateNumber: "川A00007" },
    //   { plateNumber: "川A00008" },
    //   { plateNumber: "川A00009" },
    //   { plateNumber: "川A00010" },
    //   { plateNumber: "川A00013" },
    //   { plateNumber: "川A00012" },
    //   { plateNumber: "川A00013" },
    //   { plateNumber: "川A00014" },
    //   { plateNumber: "川A00015" },
    //   { plateNumber: "川A00016" },
    // ];
    this.gettableData();
  },
  methods: {
    init() {
      /*重置数据*/
      this.tableParam.orderNo = "";
      this.tableParam.engineeringName = "";
      this.tableParam.pouringTime = "";
      this.gettableData();
    },
    /*添加关联车辆*/
    async open(low) {
      this.low = low;
      this.addDialog = true;
      await cat_list({ supplierId: low.foreignId }).then((res) => {
        this.arr1 = res.data;
        this.console(res.data);
      });
      await plan_car({ planId: low.id }).then((res) => {
        this.oldarr1 = this.copy(res.data);
        this.fromDate.arr1 = this.copy(res.data).map((res) => {
          return res.plateNumber;
        });
        this.console(res.data);
      });
    },
    del(index) {
      this.fromDate.arr1.splice(index, 1);
    },
    submit1() {
      console.log(this.oldarr1);
      console.log(this.fromDate.arr1);
      let allHasData = this.oldarr1.filter((item) =>
        this.fromDate.arr1.some((items) => item.plateNumber == items)
      );
      let deleteData = this.oldarr1.filter(
        (item) =>
          !allHasData.some((items) => item.plateNumber == items.plateNumber)
      );
      deleteData.forEach((res) => {
        res.status = 0;
      });
      let addData = this.fromDate.arr1.filter(
        (item) => !allHasData.some((items) => item == items.plateNumber)
      );
      addData = addData.map((res) => {
        let obj = {
          planId: this.low.id,
          plateNumber: res,
          status: 0,
        };
        return obj;
      });
      saveOrupdate([...allHasData, ...deleteData, ...addData]).then((res) => {
        this.console(res.data);
        this.oldarr1 = [];
        this.fromDate.arr1 = [];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.car {
  display: flex;
  flex-wrap: wrap;
  > div {
    padding: 5px 10px;
    margin: 0 10px 10px 10px;
    border: 1px solid #e1e5ed;
    border-radius: 4px;
    .iconhome_icon_txt {
      color: $bg_color;
      margin-right: 5px;
      font-size: 14px;
    }
    .iconzu2197:hover {
      color: $bg_color;
    }
    .iconzu2197 {
      margin-left: 5px;
      color: #c0c4cc;
      font-size: 14px;
    }
  }
}
.el-input,
.el-select {
  width: 240px;
}
/*
 <el-link class="table_link" :underline="false">查看配合比</el-link>*/
.table_link {
  margin: 0 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
